import React from "react";
import { ArrowUpRight } from "lucide-react";
import { BOARDS, SITE } from "../lib/data";
import SectionNumber from "./SectionNumber";

export default function Boards() {
  return (
    <section
      data-testid="boards-section"
      className="relative bg-white py-24 sm:py-32 overflow-hidden"
    >
      <SectionNumber n="07" />
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-12 gap-8 mb-14 items-end">
          <div className="md:col-span-7 reveal">
            <span className="eyebrow">Kézműves · Made in Hungary</span>
            <h2 className="font-serif text-pkcharcoal text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[1.05]">
              Kézzel készült deszkák,
              <br />
              <span className="italic text-pkred">saját történettel.</span>
            </h2>
          </div>
          <div className="md:col-span-5 reveal">
            <p className="text-pkcharcoal/70 text-base sm:text-lg leading-relaxed">
              Egyedi vágó- és tálalódeszkák természetes fából és
              epoxigyantából. Minden darab egy történet – a természet és a
              design találkozása.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {BOARDS.map((b, i) => (
            <article
              key={b.id}
              data-testid={`board-card-${i}`}
              className="group reveal"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <div className="relative aspect-[4/5] overflow-hidden bg-pkbeige">
                <img
                  src={b.img}
                  alt={b.title}
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000"
                />
                <div className="absolute top-4 left-4 bg-white px-3 py-1.5 text-[0.65rem] tracking-[0.2em] uppercase font-semibold text-pkcharcoal">
                  {b.sub}
                </div>
              </div>
              <div className="pt-6">
                <div className="flex items-start justify-between gap-4">
                  <h3 className="font-serif text-2xl text-pkcharcoal leading-tight">
                    {b.title}
                  </h3>
                  <span className="w-9 h-9 rounded-full border border-pkash flex items-center justify-center shrink-0 group-hover:bg-pkred group-hover:border-pkred transition-colors">
                    <ArrowUpRight
                      className="w-4 h-4 text-pkcharcoal group-hover:text-white transition-colors"
                      strokeWidth={1.8}
                    />
                  </span>
                </div>
                <p className="text-pkcharcoal/65 text-sm mt-3 leading-relaxed">
                  {b.desc}
                </p>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-14 text-center reveal">
          <a
            href={SITE.emailHref}
            data-testid="boards-cta"
            className="btn-ghost-dark"
          >
            Deszkák megtekintése
          </a>
          <p className="text-pkcharcoal/50 text-xs tracking-[0.15em] uppercase mt-4">
            Hamarosan webshop · Most email-en érdeklődj
          </p>
        </div>
      </div>
    </section>
  );
}
